<div>
  <div class="flex flex-row flex-wrap align-items-center my-3">
    <h3 class="text-base font-medium text-800 pr-2">
      {{'UserPages.UserContactInfo.PageTitle' | translate}}
    </h3>

    <p-button
      *ngIf="!isEdit"
      (onClick)="onEditForm()"
      icon="pi pi-pencil"
      label="{{'UserPages.UserContactInfo.EditButton' | translate}}"
      styleClass="p-button-text p-button-primary"
      class="custom-text-button"/>

    <p-button
      *ngIf="isEdit"
      (onClick)="onCancelEdit()"
      icon="pi pi-times"
      label="{{'UserPages.UserContactInfo.CancelButton' | translate}}"
      styleClass="p-button-text p-button-danger"
      class="custom-text-button button-cancel mr-2"/>

    <p-button
      *ngIf="isEdit"
      (onClick)="onSave()"
      icon="pi pi-save"
      label="{{'UserPages.UserContactInfo.SaveButton' | translate}}"
      styleClass="p-button-primary"
      class="custom-text-button"/>
  </div>

  <form [formGroup]="formGroup">
    <div class="flex flex-column">
      <div class="field-row flex w-12 border-bottom">
        <div class="w-3">
          <label for="profileType">{{'UserPages.UserContactInfo.ProfileFieldLabel' | translate}} *</label>
        </div>
        <div class="w-9">
          <span id="profileType" class="detail-text">{{profileType}}</span>
        </div>
      </div>

      <div class="field-row flex w-12 border-bottom">
        <div class="w-3">
          <label for="contactName">{{'UserPages.UserContactInfo.NameFieldLabel' | translate}} *</label>
        </div>
        <div class="w-9">
          <span *ngIf="!isEdit" class="detail-text">{{contactInfo?.contactName}}</span>
          <input
            *ngIf="isEdit"
            id="contactName"
            formControlName="contactName"
            type="text"
            required
            pInputText
            placeholder="{{'UserPages.UserContactInfo.NameFieldPlaceholder' | translate}}"
            class="custom-input"/>
          <small *ngIf="submit && formGroup.controls['contactName'].invalid"
            class="ml-2 p-error">{{getErrorMessage('contactName')}}</small>
        </div>
      </div>

      <div class="field-row flex w-12 border-bottom">
        <div class="w-3">
          <label for="contactEmail">{{'UserPages.UserContactInfo.EmailFieldLabel' | translate}} *</label>
        </div>
        <div class="w-9">
          <span *ngIf="!isEdit" class="detail-text">{{contactInfo?.contactEmail}}</span>
          <input
            *ngIf="isEdit"
            id="contactEmail"
            formControlName="contactEmail"
            type="text"
            required
            pInputText
            placeholder="{{'UserPages.UserContactInfo.EmailFieldPlaceholder' | translate}}"
            class="custom-input"/>
          <small *ngIf="submit && formGroup.controls['contactEmail'].invalid"
            class="ml-2 p-error">{{getErrorMessage('contactEmail')}}</small>
        </div>
      </div>

      <div class="field-row flex w-12 border-bottom">
        <div class="w-3">
          <label for="country">{{'UserPages.UserContactInfo.CountryFieldLabel' | translate}} *</label>
        </div>
        <div class="w-9">
          <span *ngIf="!isEdit" class="detail-text">{{selectedCountry}}</span>
          <p-dropdown
            *ngIf="isEdit"
            id="country"
            formControlName="contactCountryId"
            [options]="countries"
            optionLabel="name"
            optionValue="id"
            [filter]="true"
            filterBy="name"
            [showClear]="true"
            placeholder="{{'UserPages.UserContactInfo.CountryFieldPlaceholder' | translate}}"
            class="custom-dropdown">
          </p-dropdown>
          <small *ngIf="submit && formGroup.controls['contactCountryId'].invalid" class="ml-2 p-error">{{getErrorMessage('contactCountryId')}}</small>
        </div>
      </div>

      <div class="field-row flex w-12 border-bottom">
        <div class="w-3">
          <label for="contactCity">{{'UserPages.UserContactInfo.CityFieldLabel' | translate}} *</label>
        </div>
        <div class="w-9">
          <span *ngIf="!isEdit" class="detail-text">{{contactInfo?.contactCity}}</span>
          <input
            *ngIf="isEdit"
            id="contactCity"
            formControlName="contactCity"
            type="text"
            required
            pInputText
            placeholder="{{'UserPages.UserContactInfo.CityFieldPlaceholder' | translate}}"
            class="custom-input"/>
          <small *ngIf="submit && formGroup.controls['contactCity'].invalid"
            class="ml-2 p-error">{{getErrorMessage('contactCity')}}</small>
        </div>
      </div>

      <div class="field-row flex w-12 border-bottom">
        <div class="w-3">
          <label for="contactAddress">{{'UserPages.UserContactInfo.AddressFieldLabel' | translate}} *</label>
        </div>
        <div class="w-9">
          <span *ngIf="!isEdit" class="detail-text">{{contactInfo?.contactAddress}}</span>
          <input
            *ngIf="isEdit"
            id="contactAddress"
            formControlName="contactAddress"
            type="text"
            required
            pInputText
            placeholder="{{'UserPages.UserContactInfo.AddressContactFieldPlaceholder' | translate}}"
            class="custom-input"/>
          <small *ngIf="submit && formGroup.controls['contactAddress'].invalid"
            class="ml-2 p-error">{{getErrorMessage('contactAddress')}}</small>
        </div>
      </div>

      <div class="field-row flex w-12 border-bottom">
        <div class="w-3">
          <label for="contactPhone">{{'UserPages.UserContactInfo.PhoneFieldLabel' | translate}}</label>
        </div>
        <div class="w-9">
          <span *ngIf="!isEdit" class="detail-text">{{contactInfo?.contactPhone}}</span>
          <input
            *ngIf="isEdit"
            id="contactPhone"
            maxlength="{{formLimit.phoneLimit}}"
            formControlName="contactPhone"
            type="text"
            pInputText
            placeholder="{{'UserPages.UserContactInfo.PhoneFieldPlaceholder' | translate}}"
            class="custom-input"/>
          </div>
      </div>

      <div class="field-row flex w-12 border-bottom">
        <div class="w-3">
          <label for="lang">{{'UserPages.UserContactInfo.LangFieldLabel' | translate}} *</label>
        </div>
        <div class="w-9">
          <span *ngIf="!isEdit" class="detail-text">{{selectedLang}}</span>
          <p-dropdown
            *ngIf="isEdit"
            id="lang"
            formControlName="lang"
            [options]="langs"
            optionLabel="label"
            optionValue="value"
            placeholder="{{'UserPages.UserContactInfo.LangFieldPlaceholder' | translate}}"
            class="custom-dropdown">
          </p-dropdown>
          <small *ngIf="submit && formGroup.controls['lang'].invalid" class="ml-2 p-error">{{getErrorMessage('lang')}}</small>
        </div>
      </div>

    </div>
  </form>

  <div class="formgrid grid mt-3">
    <div class="field col-12 xl:col-6 lg:col-6">
      <p-button
        [loading]="loading"
        (onClick)="deactiveAccount()"
        label="{{'UserPages.UserContactInfo.DeactivateAccountButton' | translate}}"
        styleClass="p-button-text p-button-danger"
        class="custom-text-button deactivate-button"/>
    </div>
    <div class="field col-12 xl:col-6 lg:col-6"></div>
  </div>
</div>


<p-confirmDialog
  acceptLabel="{{'UserPages.UserContactInfo.ConfirmDialog' | translate}}"
  rejectLabel="{{'UserPages.UserContactInfo.CancelDialog' | translate}}"
  rejectButtonStyleClass="p-button-outlined" [style]="{width: '50vw'}">
</p-confirmDialog>
